import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Transition, TransitionGroup } from "react-transition-group";
import Copy from "components/copy";
import {
  ImageWrapper,
  ImageItem,
  InfoWrapper,
  InfoContent,
  ControlButtons,
  ControlButton,
  SliderItem,
} from "./index.styled";

const Slider = ({ data }) => {
  const { images, sectionClass, anchorID, contentList, color, mobileColor } =
    data;

  const [currentItem, setCurrentItem] = React.useState(0);
  React.useEffect(() => {
    let internalCurrentItem = 0;
    if (images?.length > 1) {
      const interval = setInterval(() => {
        internalCurrentItem = images?.[internalCurrentItem + 1]
          ? internalCurrentItem + 1
          : 0;
        setCurrentItem(internalCurrentItem);
      }, 15000);

      return () => clearInterval(interval);
    }
  }, [images]);
  return (
    <SliderItem className={[sectionClass]} id={anchorID}>
      <ImageWrapper>
        <TransitionGroup component={null}>
          <Transition
            key={`slider-content-item-${currentItem}`}
            timeout={{ enter: 1000, exit: 1000 }}
          >
            {(status) => (
              <>
                <ImageItem
                  key={`slider-${currentItem}`}
                  className={`${status}`}
                >
                  <GatsbyImage
                    image={getImage(images?.[currentItem].file)}
                    key={`slider-image-list-${currentItem}`}
                    style={{ width: "100%", height: "100%" }}
                    alt="text"
                  />
                </ImageItem>
              </>
            )}
          </Transition>
        </TransitionGroup>
      </ImageWrapper>
      <InfoWrapper>
        <TransitionGroup component={null}>
          <Transition
            key={`slider-content--item-${currentItem}`}
            timeout={{ enter: 500, exit: 1000 }}
          >
            {(status) => (
              <>
                <InfoContent
                  key={`slider-content-content-copy-${currentItem}`}
                  className={`${status}`}
                >
                  <Copy
                    slider={true}
                    data={contentList?.[currentItem]}
                    mobileColor={mobileColor}
                  >
                    <>
                      {images?.length > 1 && (
                        <ControlButtons>
                          {images?.map((item, index) => {
                            return (
                              <ControlButton
                                $color={color}
                                $mobileColor={mobileColor}
                                className={currentItem === index && "active"}
                                key={index}
                                onClick={() => setCurrentItem(index)}
                              />
                            );
                          })}
                        </ControlButtons>
                      )}
                    </>
                  </Copy>
                </InfoContent>
              </>
            )}
          </Transition>
        </TransitionGroup>
      </InfoWrapper>
    </SliderItem>
  );
};

export default Slider;
